import script from "./FamilyTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyTable.vue?vue&type=script&setup=true&lang=ts"

import "./FamilyTable.vue?vue&type=style&index=0&id=15d5037f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d5037f"]])

export default __exports__